import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Money from '../../../../../../../../../../../components/TableCell/components/Money'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

export default class Summary extends Component {
    static propTypes = {
        data: PropTypes.object,
    }

    render() {
        const { data } = this.props

        return (
            <div className={'grants-summary-container'}>
                <div className={'values-container'}>
                    <Money
                        value={{
                            amount: data?.consumption,
                            currency: data?.currency,
                        }}
                        valueStyle={{ fontFamily: 'Trivia Sans Black', fontSize: '48px' }}
                        showCurrency
                        currencyStyle={{ fontFamily: 'Trivia Sans Light', fontSize: '35px' }}
                        emptyValue={'0'}
                    />
                    <span>{' / '}</span>
                    <Money
                        value={{
                            amount: data?.releasedAmount,
                            currency: data?.currency,
                        }}
                        valueStyle={{ fontFamily: 'Trivia Sans Black', fontSize: '48px' }}
                        showCurrency
                        currencyStyle={{ fontFamily: 'Trivia Sans Light', fontSize: '35px' }}
                        emptyValue={'0'}
                    />
                </div>
                <div className={'summary-text-container'}>
                    <span>
                        <FormattedMessage id={`${LOCALE_PREFIX}.summaryText`} values={{ br: <br /> }} />
                    </span>
                </div>
            </div>
        )
    }
}
